import type { ReactNode } from 'react'

export type Notification = {
  text: ReactNode
  type: 'success' | 'error' | 'warning' | 'info'
}

export type AppState = {
  notification: Notification
  openModal: boolean
}

export enum NotificationTypes {
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
}
